import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectConfig } from '../../../../../shared/ui/form/select/select.component.config';
import { Option } from '../../../../../shared/models/option.model';

@Component({
    selector: 'app-contact-client-form',
    templateUrl: './contact-client-form.component.html',
    styleUrls: ['./contact-client-form.component.css'],
    standalone: false
})
export class ContactClientFormComponent implements OnInit {
    form!: UntypedFormGroup;

    formConfiguration: any = {
        paymentTypeClient: {
            label: 'Forma de cobro por defecto',
            placeholder: 'Selecciona forma de cobro por defecto',
            multiple: false,
            loadOptions: () => this.loadStreetTypes()
        },
        entranceAccount: {
            label: 'Número cuenta contable de ingreso por defecto',
            placeholder: 'Selecciona número cuenta contable de ingreso por defecto',
            multiple: false,
            loadOptions: () => this.loadStreetTypes()
        },
        paymentClientUid: {
            label: 'Número cuenta contable de ingreso por defecto',
            placeholder: 'Selecciona número cuenta contable de ingreso por defecto',
            multiple: false,
            loadOptions: () => this.loadStreetTypes()
        },
        clientEfectivoId: {
            label: 'Caja/Efectivo',
            placeholder: 'Selecciona Caja/Efectivo',
            multiple: false,
            loadOptions: () => this.loadStreetTypes()
        },
        clientPartnersId: {
            label: 'Caja/Efectivo',
            placeholder: 'Selecciona Caja/Efectivo',
            multiple: false,
            loadOptions: () => this.loadStreetTypes()
        },
        accountNumberClient: {
            label: 'Cuenta contable',
            placeholder: ''
        },
        taxClientUid: {
            label: 'Impuesto por defecto',
            placeholder: 'Impuesto por defecto',
            multiple: false,
            loadOptions: () => this.loadStreetTypes()
        },
        taxClientSecondUid: {
            label: 'Segundo impuesto por defecto',
            placeholder: 'Segundo impuesto por defecto',
            multiple: false,
            loadOptions: () => this.loadStreetTypes()
        },
        assignedCode: {
            label: 'Código asignado',
            placeholder: 'Introduce código asignado'
        },
        expirationClient: {
            label: 'Vencimiento de factura por defecto',
            placeholder: 'Introduce vencimiento de factura por defecto'
        },
        employeeId: {
            label: 'Empleado/Comercial',
            placeholder: 'Selecciona Empleado/Comercial',
            multiple: false,
            loadOptions: () => this.loadStreetTypes()
        }
    }


    constructor(private fb: UntypedFormBuilder) { }

    ngOnInit(): void {
        this.form = this.fb.group({
            paymentTypeClient: [null, Validators.required],
            paymentClientUid: [null, Validators.required],
            clientEfectivoId: [null, Validators.required],
            clientPartnersId: [null, Validators.required],
            entranceAccount: [null, Validators.required],
            accountNumberClient: [null, Validators.required],
            taxClientUid: [null, Validators.required],
            taxClientSecondUid: [null, Validators.required],
            expirationClient: [null, Validators.required],
            assignedCode: [null, Validators.required],
        });
    }

    loadStreetTypes(): Option[] {
        return [
            { value: '08', label: 'Barcelona' },
            { value: '28', label: 'Madrid' }
        ];
    }

    provinciaConfig: SelectConfig = {
        label: 'Provincia',
        placeholder: 'Selecciona provincia',
        multiple: false,
        loadOptions: () => this.loadProvincias()
    };

    municipioConfig: SelectConfig = {
        label: 'Municipio',
        placeholder: 'Selecciona municipio',
        multiple: false,
        loadOptions: () => this.loadMunicipios(this.form.get('provincia')!.value)
    };

    loadProvincias(): Option[] {
        return [
            { value: '08', label: 'Barcelona' },
            { value: '28', label: 'Madrid' }
        ];
    }

    loadMunicipios(provincia: string): Option[] {
        if (provincia === '08') {
            return [
                { value: '08019', label: 'Barcelona' },
                { value: '08101', label: 'L\'Hospitalet' }
            ];
        } else if (provincia === '28') {
            return [
                { value: '28079', label: 'Madrid' },
                { value: '28123', label: 'Getafe' }
            ];
        }
        return [];
    }

    onProvinciaChange(): void {
        const provincia = this.form.get('provincia')!.value;
        this.municipioConfig = {
            ...this.municipioConfig,
            key: Date.now(), // clave única que cambia en cada llamada
            loadOptions: () => this.loadMunicipios(provincia)
        };

        this.form.get('municipio')!.reset();
    }
}
